import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "w-full min-h-screen flex flex-col clear-both now-what" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "grid lg:grid-cols-2 gap-4 xl:gap-x-32 gap-12 pt-4" }
const _hoisted_4 = { class: "text-md" }
const _hoisted_5 = { class: "mb-8 font-space text-medium font-bold text-xl text-pxorange" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: "img/laptop.svg",
  alt: "Notebook image",
  class: "h-20 my-8 mx-16"
}, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://geology.com/articles/rare-earth-elements/"
}, "Geology Website", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://www.britannica.com/science/rare-earth-element"
}, "Encyclopedia Britannica", -1)
const _hoisted_12 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://www.br.de/wissen/seltene-erden-metalle-smartphones-china-100.html"
}, "BR Wissen", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://www.materialmagazin.com/index.php/gute-frage/sind-die-selten-erden-wirklich-selten#:~:text=Denn%20in%20erster%20Linie%20sind,1)%20isoliert%20wurden)"
}, "Material Magazin", -1)
const _hoisted_16 = [
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = { class: "mb-4" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = {
  target: "_blank",
  href: "https://materialsmatter.eu/browse"
}
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_24 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://www.susmagpro.eu/"
}, "SUSMAGPRO", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://www.sintef.no/projectweb/secreets"
}, "SecREEts", -1)
const _hoisted_26 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = { class: "mb-4" }
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("img", {
  class: "h-4 mr-1 inline align-middle",
  src: "img/twitter.svg",
  alt: "twitter logo"
}, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://twitter.com/susmagpro"
}, "@susmagpro", -1)
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" & ")
const _hoisted_33 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://twitter.com/Secreets_H2020"
}, "@Secreets_H2020", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("img", {
  class: "h-4 mr-2 inline align-middle",
  src: "img/linkedin.svg",
  alt: "linkedin logo"
}, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://www.linkedin.com/in/susmagpro-project-8a287a184/"
}, "SUSMAGPRO", -1)
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" & ")
const _hoisted_38 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://www.linkedin.com/company/secreets/"
}, "SecREEts", -1)
const _hoisted_39 = { class: "mb-4" }
const _hoisted_40 = ["innerHTML"]
const _hoisted_41 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_42 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://sdgs.un.org/"
}, "SDGs", -1)
const _hoisted_43 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_44 = ["innerHTML"]
const _hoisted_45 = { class: "text-md" }
const _hoisted_46 = { class: "mb-8 font-space text-medium font-bold text-xl text-pxorange" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("img", {
  src: "img/circle_recycle.svg",
  alt: "Recycle circle",
  class: "h-20 my-8 mx-16"
}, null, -1)
const _hoisted_48 = { class: "pl-4" }
const _hoisted_49 = { class: "list-disc mb-4" }
const _hoisted_50 = ["innerHTML"]
const _hoisted_51 = {
  key: 0,
  class: "list-disc mb-4"
}
const _hoisted_52 = ["innerHTML"]
const _hoisted_53 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://weee4future.eitrawmaterials.eu/e-waste-calculator/"
}, null, -1)
const _hoisted_54 = ["innerHTML"]
const _hoisted_55 = {
  key: 1,
  class: "list-disc mb-4"
}
const _hoisted_56 = ["innerHTML"]
const _hoisted_57 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://weee4future.eitrawmaterials.eu/de/e-mull-rechner/"
}, " E-Müll-Rechner ", -1)
const _hoisted_58 = ["innerHTML"]
const _hoisted_59 = { class: "list-disc mb-4" }
const _hoisted_60 = ["innerHTML"]
const _hoisted_61 = /*#__PURE__*/_createElementVNode("img", {
  class: "h-4 mr-1 inline align-middle",
  src: "img/bubble.svg",
  alt: "bubble logo"
}, null, -1)
const _hoisted_62 = ["innerHTML"]
const _hoisted_63 = /*#__PURE__*/_createElementVNode("img", {
  class: "h-4 mr-1 inline align-middle",
  src: "img/bubble.svg",
  alt: "bubble logo"
}, null, -1)
const _hoisted_64 = ["innerHTML"]
const _hoisted_65 = /*#__PURE__*/_createElementVNode("img", {
  class: "h-4 mr-1 inline align-middle",
  src: "img/bubble.svg",
  alt: "bubble logo"
}, null, -1)
const _hoisted_66 = ["innerHTML"]
const _hoisted_67 = { class: "text-md" }
const _hoisted_68 = { class: "mb-8 font-space text-medium font-bold text-xl text-pxorange" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("img", {
  src: "img/message_blob.svg",
  alt: "Message blob",
  class: "h-20 my-8 mx-16"
}, null, -1)
const _hoisted_70 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_71 = ["innerHTML"]
const _hoisted_72 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://www.bbc.com/news/world-17357863"
}, "BBC Article", -1)
const _hoisted_74 = /*#__PURE__*/_createTextVNode()
const _hoisted_75 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://www.ellenmacarthurfoundation.org/circular-economy/concept"
}, "Ellen MacArthur Foundation", -1)
const _hoisted_77 = /*#__PURE__*/_createTextVNode()
const _hoisted_78 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_79 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://ec.europa.eu/environment/circular-economy/index_en.htm"
}, "European Commission = DG Environment", -1)
const _hoisted_80 = /*#__PURE__*/_createTextVNode()
const _hoisted_81 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_82 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_83 = ["innerHTML"]
const _hoisted_84 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://www.br.de/wissen/seltene-erden-metalle-smartphones-china-100.html"
}, "BR Wissen", -1)
const _hoisted_86 = /*#__PURE__*/_createTextVNode()
const _hoisted_87 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_88 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://www.spiegel.de/wissenschaft/weltall/bayan-obo-satellitenbild-zeigt-mine-fuer-seltene-erden-in-china-a-827334.html"
}, "Spiegel Wissenschaft", -1)
const _hoisted_89 = /*#__PURE__*/_createTextVNode()
const _hoisted_90 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_91 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://www.europarl.europa.eu/news/de/headlines/economy/20151201STO05603/kreislaufwirtschaft-definition-und-vorteile"
}, "Europäisches Parlement", -1)
const _hoisted_92 = /*#__PURE__*/_createTextVNode()
const _hoisted_93 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_94 = { class: "text-md" }
const _hoisted_95 = { class: "mb-8 font-space text-medium font-bold text-xl text-pxorange" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("img", {
  src: "img/question.svg",
  alt: "Message blob",
  class: "h-20 my-8 mx-16"
}, null, -1)
const _hoisted_97 = { class: "mb-4" }
const _hoisted_98 = ["innerHTML"]
const _hoisted_99 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_100 = /*#__PURE__*/_createElementVNode("a", { href: "mailto:discoverees@prospex-institute.org" }, "discoverees@prospex-institute.org", -1)
const _hoisted_101 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_102 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_ScreenWrapper, {
      next: _ctx.next,
      "hide-arrow": "true"
    }, {
      default: _withCtx(() => [
        _createElementVNode("h3", {
          innerHTML: _ctx.$t('nowWhat.title'),
          class: "mb-8 font-space text-medium font-bold text-xl"
        }, null, 8, _hoisted_2),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h4", _hoisted_5, " 1. " + _toDisplayString(_ctx.$t('nowWhat.section1.title')), 1),
            _hoisted_6,
            (_ctx.$root.$i18n.locale == 'en')
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                  _createElementVNode("span", {
                    innerHTML: _ctx.$t('nowWhat.section1.text1')
                  }, null, 8, _hoisted_8),
                  _hoisted_9,
                  _hoisted_10,
                  _hoisted_11
                ]))
              : _createCommentVNode("", true),
            (_ctx.$root.$i18n.locale == 'de')
              ? (_openBlock(), _createElementBlock("p", _hoisted_12, _hoisted_16))
              : _createCommentVNode("", true),
            _createElementVNode("p", _hoisted_17, [
              _createElementVNode("span", {
                innerHTML: _ctx.$t('nowWhat.section1.text2')
              }, null, 8, _hoisted_18),
              _createElementVNode("a", _hoisted_19, [
                _createElementVNode("span", {
                  innerHTML: _ctx.$t('nowWhat.section1.text8')
                }, null, 8, _hoisted_20)
              ]),
              _hoisted_21,
              _createElementVNode("span", {
                innerHTML: _ctx.$t('nowWhat.section1.text3')
              }, null, 8, _hoisted_22),
              _hoisted_23,
              _hoisted_24,
              _createTextVNode("  " + _toDisplayString(_ctx.$t('and')) + "  ", 1),
              _hoisted_25,
              _hoisted_26,
              _createElementVNode("span", {
                innerHTML: _ctx.$t('nowWhat.section1.text4')
              }, null, 8, _hoisted_27)
            ]),
            _createElementVNode("p", _hoisted_28, [
              _createElementVNode("span", {
                innerHTML: _ctx.$t('nowWhat.section1.text5')
              }, null, 8, _hoisted_29),
              _hoisted_30,
              _hoisted_31,
              _hoisted_32,
              _hoisted_33,
              _hoisted_34,
              _hoisted_35,
              _hoisted_36,
              _hoisted_37,
              _hoisted_38
            ]),
            _createElementVNode("p", _hoisted_39, [
              _createElementVNode("span", {
                innerHTML: _ctx.$t('nowWhat.section1.text6')
              }, null, 8, _hoisted_40),
              _hoisted_41,
              _hoisted_42,
              _hoisted_43,
              _createElementVNode("span", {
                innerHTML: _ctx.$t('nowWhat.section1.text7')
              }, null, 8, _hoisted_44)
            ])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("h4", _hoisted_46, " 2. " + _toDisplayString(_ctx.$t('nowWhat.section2.title')), 1),
            _hoisted_47,
            _createElementVNode("ul", _hoisted_48, [
              _createElementVNode("li", _hoisted_49, [
                _createElementVNode("span", {
                  innerHTML: _ctx.$t('nowWhat.section2.text1')
                }, null, 8, _hoisted_50)
              ]),
              (_ctx.$root.$i18n.locale == 'en')
                ? (_openBlock(), _createElementBlock("li", _hoisted_51, [
                    _createElementVNode("span", {
                      innerHTML: _ctx.$t('nowWhat.section2.text2')
                    }, null, 8, _hoisted_52),
                    _hoisted_53,
                    _createElementVNode("span", {
                      innerHTML: _ctx.$t('nowWhat.section2.text3')
                    }, null, 8, _hoisted_54)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.$root.$i18n.locale == 'de')
                ? (_openBlock(), _createElementBlock("li", _hoisted_55, [
                    _createElementVNode("span", {
                      innerHTML: _ctx.$t('nowWhat.section2.text2')
                    }, null, 8, _hoisted_56),
                    _hoisted_57,
                    _createElementVNode("span", {
                      innerHTML: _ctx.$t('nowWhat.section2.text3')
                    }, null, 8, _hoisted_58)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("li", _hoisted_59, [
                _createElementVNode("span", {
                  innerHTML: _ctx.$t('nowWhat.section2.text4')
                }, null, 8, _hoisted_60),
                _hoisted_61,
                _createElementVNode("span", {
                  innerHTML: _ctx.$t('nowWhat.section2.text5')
                }, null, 8, _hoisted_62),
                _hoisted_63,
                _createElementVNode("span", {
                  innerHTML: _ctx.$t('nowWhat.section2.text6')
                }, null, 8, _hoisted_64),
                _hoisted_65,
                _createElementVNode("span", {
                  innerHTML: _ctx.$t('nowWhat.section2.text7')
                }, null, 8, _hoisted_66)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("h4", _hoisted_68, " 3. " + _toDisplayString(_ctx.$t('nowWhat.section3.title')), 1),
            _hoisted_69,
            (_ctx.$root.$i18n.locale == 'en')
              ? (_openBlock(), _createElementBlock("p", _hoisted_70, [
                  _createElementVNode("span", {
                    innerHTML: _ctx.$t('nowWhat.section3.text1')
                  }, null, 8, _hoisted_71),
                  _hoisted_72,
                  _hoisted_73,
                  _hoisted_74,
                  _hoisted_75,
                  _hoisted_76,
                  _hoisted_77,
                  _hoisted_78,
                  _hoisted_79,
                  _hoisted_80,
                  _hoisted_81
                ]))
              : _createCommentVNode("", true),
            (_ctx.$root.$i18n.locale == 'de')
              ? (_openBlock(), _createElementBlock("p", _hoisted_82, [
                  _createElementVNode("span", {
                    innerHTML: _ctx.$t('nowWhat.section3.text1')
                  }, null, 8, _hoisted_83),
                  _hoisted_84,
                  _hoisted_85,
                  _hoisted_86,
                  _hoisted_87,
                  _hoisted_88,
                  _hoisted_89,
                  _hoisted_90,
                  _hoisted_91,
                  _hoisted_92,
                  _hoisted_93
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_94, [
            _createElementVNode("h4", _hoisted_95, " 4. " + _toDisplayString(_ctx.$t('nowWhat.section4.title')), 1),
            _hoisted_96,
            _createElementVNode("p", _hoisted_97, [
              _createElementVNode("span", {
                innerHTML: _ctx.$t('nowWhat.section4.text1')
              }, null, 8, _hoisted_98),
              _hoisted_99,
              _hoisted_100,
              _hoisted_101
            ])
          ])
        ]),
        _createElementVNode("img", {
          class: "w-full mx-auto",
          src: _ctx.localizedImage('img/GIF_3.gif'),
          alt: "Spread the work animation"
        }, null, 8, _hoisted_102)
      ]),
      _: 1
    }, 8, ["next"])
  ]))
}